var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/containers/quoted-status-container.tsx";
import React, { useCallback } from 'react';
import { cancelQuoteCompose } from 'soapbox/actions/compose';
import QuotedStatus from 'soapbox/components/quoted-status';
import { useAppSelector, useAppDispatch } from 'soapbox/hooks';
import { makeGetStatus } from 'soapbox/selectors';

/** QuotedStatus shown in post composer. */
const QuotedStatusContainer = _ref => {
  let {
    composeId
  } = _ref;
  const dispatch = useAppDispatch();
  const getStatus = useCallback(makeGetStatus(), []);
  const status = useAppSelector(state => {
    var _state$compose$get;

    return getStatus(state, {
      id: (_state$compose$get = state.compose.get(composeId)) === null || _state$compose$get === void 0 ? void 0 : _state$compose$get.quote
    });
  });

  const onCancel = () => {
    dispatch(cancelQuoteCompose());
  };

  if (!status) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "mb-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(QuotedStatus, {
    status: status,
    onCancel: onCancel,
    compose: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 7
    }
  }));
};

export default QuotedStatusContainer;